import ShortcutDisplay from "../../../../src/components/ShortcutDisplay";
import panel from "../../../../assets/images/docs/panel.png";
import paneltabs from "../../../../assets/videos/blogs/pp29/paneltabs.mp4";
import * as React from 'react';
export default {
  ShortcutDisplay,
  panel,
  paneltabs,
  React
};